export const M_SET_LOCALIZE_LIST = "M_SET_LOCALIZE_LIST";
export const M_SET_SETTINGS = "M_SET_SETTINGS";
export const M_SET_CURRENCY = "M_SET_CURRENCY";
export const M_LOCALIZE = "M_LOCALIZE";
export const M_SET_ALERT = "M_SET_ALERT";
export const M_SHOW_POPOVER = "M_SHOW_POPOVER";
export const M_HIDE_POPOVER = "M_HIDE_POPOVER";
export const M_SET_SERVER_OFF = "M_SET_SERVER_OFF";
export const M_SET_PATH = "M_SET_PATH";
export const M_SET_API_URL = "M_SET_API_URL";
export const M_SET_API_ORIGIN = "M_SET_API_ORIGIN";
export const M_SET_LOCALIZE_ERROR = "M_SET_LOCALIZE_ERROR";
export const M_SET_QUOTA_SERVICES = "M_SET_QUOTA_SERVICES";
export const M_SET_CONFIG_URLS = "M_SET_CONFIG_URLS";
export const M_SET_CURRENCY_RATES = "M_SET_CURRENCY_RATES";
export const M_CHANGE_THEME = "M_CHANGE_THEME";
export const M_SET_ALL_CURRENCY = "M_SET_ALL_CURRENCY";
